import React from "react";

export default function CopyWorkflowOption({
    icon: Icon,
    iconBgClass,
    iconColorClass,
    label,
    description,
    badge,
    selected,
    onClick,
    autoFocus,
}) {
    return (
        <button
            type="button"
            onClick={onClick}
            autoFocus={autoFocus}
            aria-pressed={selected}
            className={`group w-full text-left flex gap-3 p-4 rounded-lg border-2 transition-all
                focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500
                ${
                    selected
                        ? "border-blue-500 bg-blue-50/60 shadow-sm"
                        : "border-gray-200 hover:border-gray-300 hover:bg-gray-50"
                }`}
        >
            <div
                className={`shrink-0 w-10 h-10 rounded-md flex items-center justify-center ${iconBgClass}`}
            >
                <Icon className={`w-5 h-5 ${iconColorClass}`} />
            </div>
            <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                    <span className="font-semibold text-sm text-gray-900">
                        {label}
                    </span>
                    {badge && (
                        <span className="text-[10px] uppercase tracking-wide font-semibold px-1.5 py-0.5 rounded bg-blue-100 text-blue-700">
                            {badge}
                        </span>
                    )}
                </div>
                <p className="text-xs text-gray-600 mt-1 leading-relaxed">
                    {description}
                </p>
            </div>
            <div
                className={`shrink-0 self-start mt-1 w-4 h-4 rounded-full border-2 transition-colors ${
                    selected
                        ? "border-blue-500 bg-blue-500"
                        : "border-gray-300 group-hover:border-gray-400"
                }`}
            >
                {selected && (
                    <div className="w-1.5 h-1.5 bg-white rounded-full m-auto mt-[3px]" />
                )}
            </div>
        </button>
    );
}
